import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    CurrentAttachmentVersionDto,
    DisplayNotice,
    NoticeDto,
    Organisation
} from '@flyfreely-portal-ui/flyfreely';
import bbox from '@turf/bbox';
import { BBox } from 'geojson';
import { mergeFeatureCollectionWithSprites } from 'libs/map/src/lib/flyfreely-map/helpers';
import { MapDataInput } from 'libs/map/src/lib/index';
import {
    formatLotamAudience,
    formatLotamPriority,
    formatOperatingRequirement
} from 'libs/notices/src/lib/lotam-data.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'lotam-details',
    templateUrl: './lotam-details.component.html',
    styleUrls: ['./lotam-details.component.scss']
})
export class LotamDetailsComponent implements OnInit, OnDestroy {
    downloadUrlFn = (attachment: CurrentAttachmentVersionDto) => {
        return `/webapi/notices/${this.lotam.id}/attachments`;
    };
    @Input() lotam?: DisplayNotice;
    @Input() organisation: Organisation;

    mapData$ = new BehaviorSubject<MapDataInput>({});

    noticeBoundingBox?: BBox;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(private modal: BsModalRef<LotamDetailsComponent>) {}

    ngOnInit(): void {
        if (this.lotam?.displayLocation != null) {
            const features = mergeFeatureCollectionWithSprites([
                this.lotam?.displayLocation
            ]);

            this.noticeBoundingBox = bbox(features.featureCollection);

            this.mapData$.next({
                LOTAM: features
            });
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    protected readonly formatLotamPriority = formatLotamPriority;
    protected readonly formatAudience = formatLotamAudience;
    protected readonly formatOperatingRequirement = formatOperatingRequirement;

    get hasLocation() {
        return this.lotam != null && this.lotam.displayLocation != null;
    }

    cancel() {
        this.modal.hide();
    }

    protected readonly NoticeDto = NoticeDto;
}
